module.exports = __webpack_public_path__ + "img/mediaFullScreen.7a521ee2.svg";